import { create } from "zustand";

import axios from "../helper/axios";

const useMyTimeSheetStore = create((set) => ({
    dailyAttendance: null,
    monthlyAttendance: [],
    yearlyAttendance: [],
    attendanceUpdateFlag:false,
    monthlyAttendanceUpdateFlag:false,
    yearlyAttendanceUpdateFlag:false,
    leaveUpdateFlag:false,
    myLeaveApplications:null,
    myLeaveConfigList:null,
    myUsedLeavesList:null,

    applyLeave: async (body) => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.post(
                `/applyleave/${userData.qhoid}/${userData.qhuid}/${userData.username}`,
                body
            );
            set({ leaveUpdateFlag: true });  
        } catch (err) {
            console.error(err);
        }
    },
    getMyLeaveApplications: async () => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.get(
                `/getMyLeaveApplications/${userData.qhoid}/${userData.qhuid}/${userData.username}`
            );
            console.log("getMyLeaveApplication", response.data)
            set({ myLeaveApplications: response.data.data  });  
        } catch (err) {
            console.error(err);
        }
    },    

    doCheckinCheckout: async (body) => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.post(
                `/docheckincheckout/${userData.qhoid}/${userData.qhuid}/${userData.username}`,
                body
            );
            set({ attendanceUpdateFlag: true });  
        } catch (err) {
            console.error(err);
        }
    }, 
    getTodaysAttendance: async (year,month,day) => {
        try {
            console.log("getTodaysAttendance req", year,month,day)
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.get(
                `/getTodaysAttendance/${userData.qhoid}/${userData.qhuid}/${userData.username}/${year}/${month}/${day}`
            );
            console.log("getTodaysAttendance", response.data)
            set({ dailyAttendance: response.data.data });                                  
        } catch (err) {
            console.error(err);
        }
    },
    getMonthlyAttendance: async (body) => {
        try {
            console.log("getMonthlyAttendance",body)
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.get(
                `/getMonthlyAttendance/${userData.qhoid}/${userData.qhuid}/${userData.username}/${body.year}/${body.month}`
            );
            console.log("getMonthlyAttendance", response.data)
            set({ monthlyAttendance: response.data.data });                       
        } catch (err) {
            console.error(err);
        }
    },
    getYearlyAttendance: async (body) => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.get(
                `/getYearlyAttendance/${userData.qhoid}/${userData.qhuid}/${userData.username}/${body.year}`
            );
            console.log("getYearlyAttendance", response.data)
            set({ yearlyAttendance: response.data.data });                        
        } catch (err) {
            console.error(err);
        }
    },
    getMyLeavesConfigList: async () => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.get(
                `/getmyLeavesConfigList/${userData.qhoid}/${userData.qhuid}`
            );
            console.log("getmyLeavesConfigList", response.data)
            set({ myLeaveConfigList: response.data.data });  
            set({ myUsedLeavesList: response.data.availLeavesList});  
            
                                
        } catch (err) {
            console.error(err);
        }
    },  
    resetFlags: () => {
        set({ attendanceUpdateFlag: false });
    },  
    resetLeaveFlag: () => {
        set({ leaveUpdateFlag: false });
    },                  
}));

export default useMyTimeSheetStore;
